import {
  BannerFourOnOne,
  BannerThreeOnOne,
  EBannerInternalViewModel
} from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BannerDesignsMetadata } from './types';

const fourOnOne: BannerDesignsMetadata = {
  id: EBannerInternalViewModel.FOUR_ON_ONE,
  theme: EThemes.ROYAL_BLAST,
  version: '1.0.0',
  name: '4:1 Ratio',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/banners/banner_4_on_1.png'
  ],
  ratio: '1:1',
  component: BannerFourOnOne
};

const threeOnOne: BannerDesignsMetadata = {
  id: EBannerInternalViewModel.THREE_ON_ONE,
  theme: EThemes.ROYAL_BLAST,
  version: '1.0.0',
  name: '3:1 Ratio',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/banners/banner_3_on_1.png'
  ],
  ratio: '2:3',
  component: BannerThreeOnOne
};

export const bannerDesigns = {
  fourOnOne,
  threeOnOne
};

export const bannerDesignsByTheme: Record<EThemes, BannerDesignsMetadata[]> =
  Object.values(bannerDesigns).reduce(
    (acc, design) => {
      if (!acc[design.theme]) {
        acc[design.theme] = [];
      }
      acc[design.theme].push(design);
      return acc;
    },
    {} as Record<EThemes, BannerDesignsMetadata[]>
  );

export const bannerDesignsById: Record<string, BannerDesignsMetadata> =
  Object.values(bannerDesigns).reduce(
    (acc, design) => {
      acc[design.id] = design;
      return acc;
    },
    {} as Record<string, BannerDesignsMetadata>
  );
